import React from 'react';
import c from 'classnames';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import withSearch from '../../_hocs/withSearch';
import { getTransKeyForMediaSourceType } from './_helpers';
import s from './MediaSourceMenu.scss';
const enhance = compose(withCurrentMediaSource, withSearch);
export const MediaSourceMenu = ({ currentMediaSource, mediaSourceTypes, changeCurrentMediaSource, unsetSearchInput, unsetSearchQuery })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        id: "media-source-menu",
        className: s['root'],
        lightText: true,
        withCardWrapper: false,
        items: mediaSourceTypes.map((mediaSourceType)=>({
                label: t(getTransKeyForMediaSourceType(mediaSourceType)),
                selected: mediaSourceType === currentMediaSource,
                className: c(s['menu-item'], mediaSourceType === currentMediaSource && s['selected']),
                onClick: ()=>{
                    unsetSearchInput();
                    unsetSearchQuery();
                    changeCurrentMediaSource(mediaSourceType);
                }
            })),
        hideCheckIcon: true
    });
};
MediaSourceMenu.displayName = 'MediaSourceMenu';
export default enhance(MediaSourceMenu);
